import { render } from "./FileDetails.vue?vue&type=template&id=a8cf758c"
import script from "./FileDetails.vue?vue&type=script&lang=js"
export * from "./FileDetails.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__